import { z } from "zod";
import { defineControl, placeholderFieldSchema } from "./field.js";
export const number = defineControl({
    key: "number",
    label: "Number field",
    schema: placeholderFieldSchema("number"),
    answer: z.number(),
    isClearable: true,
    empty: { placeholder: "", required: false },
});
